import * as React from "react";

const SvgComponent = ({ bg = "transparent", color = "var(--filter-bar-btn-border)", stroke = "var(--filter-bar-btn-border)", ...props }) => (
  <svg
    width={30}
    height={30}
    fill={bg}
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <path
      d="M20 13.836h-4.635L17.535 5 10 16.712h4.635l-2.17 8.836L20 13.836Z"
      fill={color}
      opacity={0.6}
    />
  </svg>
);

export default SvgComponent;
